import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { OrderRateReasonFilterEntity } from '../../domain/entities/OrderRateReasonFilterEntity'

export class OrderRateReasonFilterModel extends OrderRateReasonFilterEntity {
  channelId?: number
  constructor(dataDto: OrderRateReasonFilterEntity) {
    super()
    mapEntityProperties<OrderRateReasonFilterModel>(this, dataDto, {
      exclude: ['channel'],
      map: {
        channelId: dataDto.channel?.id
      }
    })
  }
}
